import React, { useState, useEffect, useCallback } from 'react'
import { Icon } from '@iconify/react'

export default function ChangePage({
  currentPage,
  totalPages,
  onPageChange,
  totalItems,
  objectName,
}) {
  const [showPageNumbers, setShowPageNumbers] = useState(false)
  const [inputPage, setInputPage] = useState(currentPage)

  const handlePrevPage = useCallback(() => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1)
    }
  }, [currentPage, onPageChange])

  const handleNextPage = useCallback(() => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1)
    }
  }, [currentPage, totalPages, onPageChange])

  const handlePageClick = (pageNum) => {
    onPageChange(pageNum)
  }
  const handleInputChange = (e) => {
    const value = e.target.value
    if (/^\d*$/.test(value)) {
      // Chỉ cho phép nhập số
      setInputPage(value)
    }
  }

  const handlePageChange = () => {
    if (inputPage === '') return // Bỏ qua nếu input rỗng
    const newPage = Math.max(1, Math.min(Number(inputPage), totalPages)) // Đảm bảo trang hợp lệ
    if (newPage !== currentPage) {
      // Chỉ thay đổi khi trang khác nhau
      onPageChange(newPage)
    }
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handlePageChange()
    }
  }

  const handleBlur = () => {
    if (inputPage === '') {
      setInputPage(currentPage) // Giữ lại trang hiện tại nếu input rỗng
      return
    }
    const newPage = Math.max(1, Math.min(Number(inputPage), totalPages)) // Đảm bảo rằng giá trị nhập vào là số hợp lệ
    if (newPage !== currentPage) {
      onPageChange(newPage)
    } else {
      setInputPage(currentPage) // Đặt lại input nếu trang không thay đổi
    }
  }

  useEffect(() => {
    setInputPage(currentPage)
  }, [currentPage])

  useEffect(() => {
    const handleArrowKeys = (e) => {
      if (e.key === 'ArrowLeft') {
        handlePrevPage()
      } else if (e.key === 'ArrowRight') {
        handleNextPage()
      }
    }

    window.addEventListener('keydown', handleArrowKeys)

    return () => {
      window.removeEventListener('keydown', handleArrowKeys)
    }
  }, [handlePrevPage, handleNextPage])

  const renderPageNumbers = () => {
    const pages = []
    const maxPageRange = 3 // Số trang hiển thị bên trái và bên phải
    const startPage = Math.max(1, currentPage - maxPageRange)
    const endPage = Math.min(totalPages, currentPage + maxPageRange)

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <button
          key={i}
          className={`mx-1 w-[6ch] rounded-md px-3 py-1 text-center ${
            currentPage === i ? 'bg-[#303030] text-white' : 'bg-gray-300'
          }`}
          onClick={() => handlePageClick(i)}
        >
          {i}
        </button>
      )
    }

    return pages
  }
  if (totalPages == 0) {
    return <></>
  }
  return (
    <div className="mt-2 flex items-center justify-end">
      <span className="mr-4 text-[#909090]">
        Đang hiển thị {totalItems} {objectName}
      </span>
      {showPageNumbers && renderPageNumbers()}
      <button
        className="rounded-md py-1 pr-4"
        onClick={handlePrevPage}
        disabled={currentPage === 1}
      >
        <Icon
          icon="ph:caret-left"
          className={`global-icon mx-auto ${
            currentPage === 1 ? 'text-[#909090]' : 'text-black'
          }`}
        />
      </button>
      <span className="flex w-[4rem] cursor-pointer justify-center text-center text-lg font-semibold">
        <input
          type="text"
          value={inputPage}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown} // Sử dụng onKeyDown để xử lý Enter
          onBlur={handleBlur} // Xử lý khi người dùng rời khỏi input
          className="min-w-[5ch] rounded-md text-center"
        />
        {''}
        <span
          className="cursor-pointer"
          onClick={() => setShowPageNumbers(!showPageNumbers)} // Toggle danh sách trang khi bấm vào dấu "/"
        >
          /{''}
        </span>
        <p className="min-w-[5ch]">{totalPages <= 0 ? 1 : totalPages}</p>
      </span>

      <button
        className="rounded-md py-1 pl-4"
        onClick={handleNextPage}
        disabled={currentPage === totalPages}
      >
        <Icon
          icon="ph:caret-right"
          className={`global-icon mx-auto ${
            currentPage === totalPages ? 'text-[#909090]' : 'text-black'
          }`}
        />
      </button>
    </div>
  )
}
